import 'bootstrap/dist/css/bootstrap.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import store from './store'


//FontAwesome stuff
library.add(fas);

//Create WebApp
let app = createApp(App)

app.use(store);
app.use(Quasar, quasarUserOptions).use(router).component('fa', FontAwesomeIcon).mount('#app');